module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option-general', {
    attrs: {
      "value": "until_action",
      "label": _vm.$t('edit.sidebar.until_action')
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-3eedb5ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionfrequency/options/UntilAction.vue
 ** module id = 806
 ** module chunks = 1
 **/